var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyWalletWithdrawIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003371",
    d: "M7.963 25.95a1.16 1.16 0 001.162 1.162h11.75a1.161 1.161 0 001.163-1.162V8.975H7.963V25.95zM19.4 13.937a.469.469 0 01.938 0v4.481a.469.469 0 01-.938 0v-4.48zm0 6.394a.469.469 0 11.938 0v4.481a.469.469 0 01-.938 0v-4.481zm-2.143-6.394a.469.469 0 01.937 0v4.481a.468.468 0 11-.937 0v-4.48zm0 6.394a.469.469 0 11.937 0v4.481a.468.468 0 11-.937 0v-4.481zm-7.12-8.675a1.74 1.74 0 112.45 1.587 1.744 1.744 0 11-1.412 0 1.729 1.729 0 01-1.037-1.587zm0 9.675h3.482v3.481h-3.481v-3.481z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003371",
    d: "M28.175 2.887H1.825a1.2 1.2 0 00-1.2 1.2v10.231a1.2 1.2 0 001.2 1.2h5.2v-5.156h-.706a1.163 1.163 0 010-2.325h17.537a1.163 1.163 0 110 2.325h-.881v5.156h5.2a1.2 1.2 0 001.2-1.2V4.087a1.2 1.2 0 00-1.2-1.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWalletWithdrawIcon);
export default __webpack_public_path__ + "static/media/myWalletWithdrawIcon.35d97581a22a6d092a472b420dbaed52.svg";
export { ForwardRef as ReactComponent };